import { find, memoize } from "lodash";

import type { IShareUserExtended } from "app/sharing/SharingService";
import type { IDashboardExtended } from "app/components/dashboard/services/IDashboard";

const getUserById = memoize((userId: number, users: IShareUserExtended[]) => {
    return find(users, { id: userId });
});

export const getDashboardViewersAndOwnerName = (
    usersIdsSharedWith: number[],
    users: IShareUserExtended[],
    currentDashboard: IDashboardExtended,
    dashboardOwnerNameInitial: string,
): { viewers: IShareUserExtended[]; ownerName: string } => {
    const viewers = usersIdsSharedWith.map((id) => getUserById(id, users)).filter(Boolean);
    const ownerName = getUserById(currentDashboard.ownerId, users)?.text ?? dashboardOwnerNameInitial;

    return { viewers, ownerName };
};
